module.exports = __webpack_public_path__ + "img/nice-basic.b84f8687.png";